import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserEdit } from '../../models/user-edit.model';
import { HttpErrorResponse } from '@angular/common/http';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UserService } from 'src/app/shared/services/common/user.service';
import { UsersService } from 'src/app/shared/services/common/users.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})

export class ChangePasswordComponent implements OnInit {
  userEdit = new UserEdit('', '');
  tokencode = '';
  tokenValid: boolean;
  isLoading = false;
  pwUpdated = false;
  isError = false;
  pwMismatch = false;
  pwValid = false;
  showRules = false;
  samePhrase = false;
  isPassUsed = false;
  curpassword = '';
  password = '';
  repassword = '';
  passCharcters: string;
  passStrength: string;
  strength = null;
  inputType1 = 'password';
  inputType2 = 'password';
  inputType3 = 'password';
  spChars = '`~!@#$%^&*()-_=+[]{}|\\:;\'\",.<>?/';
  @Output() changeStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  config: any;

  constructor(
    private usersService: UsersService,
    private userService: UserService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.config = this.readConfigService.getContactUpdateText('Password');
  }

  changePassword() {
    this.isLoading = true;
    this.userService.getChangePasswordEndpoint(this.curpassword, this.password).subscribe((ret: any) => {
      if (ret.success) {
        this.isLoading = false;
        this.pwUpdated = ret.success;
        this.changeStatus.emit(ret.success);
      } else {
        this.isLoading = false;
        this.isError = true;
        this.changeStatus.emit(false);
      }
    },
      error => {
        console.log(error);
        this.isLoading = false;
        this.isError = true;
        this.changeStatus.emit(false);
      });
  }

  displayError(): boolean {
    const confirmPswrd = this.repassword;
    if (confirmPswrd && confirmPswrd.length > 0) {
      return (confirmPswrd !== this.password);
    }
    return false;
  }

  displayMatchingError(): boolean {
    const newPswrd = this.password;
    const currPswrd = this.curpassword;
    if (currPswrd && currPswrd.length > 0 && newPswrd && newPswrd.length > 0) {
      return (newPswrd === currPswrd);
    }
    return false;
  }

  disableButton() {
    return !(
      this.password.length > 0 && this.repassword === this.password && this.curpassword.length > 0
      && this.password !== this.curpassword && this.password.length > 7);
  }

  scorePassword(pass: any) {
    let score = 0;
    if (!pass) {
      return score;
    }
    // award every unique letter until 5 repetitions
    const letters = new Object();
    for (const i of pass) {
      letters[i] = (letters[i] || 0) + 1;
      score += 5.0 / letters[i];
    }
    // bonus points for mixing it up
    const variations = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass),
    };
    let variationCount = 0;
    Object.keys(variations).forEach(element => {
      variationCount += (variations[element] === true) ? 1 : 0;
    });
    score += (variationCount - 1) * 10;
    return score;
  }

  checkPassStrength(pass: any) {
    const score = this.scorePassword(pass);
    if (score > 80) {
      return 'Strong';
    }
    if (score > 60) {
      return 'Good';
    }
    if (score >= 5) {
      return 'Weak';
    }
    return null;
  }

  textChange() {
    if (this.password) {
      this.password = this.password.replace(/[+]/g, '').replace(/^\s+/g, '');
      this.repassword = null;
      const pass = this.password;
      if (pass.length < 8) {
        this.passCharcters = 'text-red';
      } else {
        this.passCharcters = 'text-green';
      }
      this.strength = this.checkPassStrength(pass);
      if (this.strength === 'Weak' || this.strength === null) {
        this.passStrength = 'text-red';
      } else {
        this.passStrength = 'text-green';
      }
    } else {
      this.strength = null;
      this.passCharcters = 'text-black';
      this.passStrength = 'text-black';
    }
  }

  onFocus(): void {
    this.showRules = true;
  }

  onBlur(value: any) {
    this.showRules = false;
    this.isPassUsed = false;
    if (!this.samePhrase && value && value.length > 0) {
      this.userService.isPwdUsed(this.usersService.encrypt(value.trim(), 'post')).subscribe((data: any) => {
        if (data.result === true) {
          this.isPassUsed = true;
        } else {
          this.isPassUsed = false;
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.isPassUsed = true;
          this.notificationService.setErrorNotification();
        });
    }
  }
}
